import { useSnapshot } from "valtio";
import { state } from "../context/store";

function getKatanaSkew() {
  const snap = useSnapshot(state.current);

  let isRed = false;
  let isSideRed = false;
  let isTopRed = false;
  let isRibRed = false;

  const matchTopLogo = (isRed) => {
    if (isSideRed | isTopRed | isRibRed) isRed = true;

    const size = (string) => {
      switch (string) {
        case "large":
          return isRed ? "LGRENJ" : "LGENJ";
        case "small":
          return isRed ? "SMRENJ" : "SMENJ";
        case "none":
          return "None";
        default:
          return "";
      }
    };

    const design = (choice) => {
      switch (choice) {
        case "ENJ":
          return size(snap.initialChoices.logoSize); // special case
        default:
          return choice;
      }
    };

    return "-" + design(snap.choices.topLogo.selected.abrv);
  };

  const matchStyle = (string) => {
    switch (string) {
      case "no":
        return "-STD-";
      default:
        return "-RIB-";
    }
  };
  const matchSideColor = (string) => {
    isSideRed = false;
    switch (string) {
      case "BRRED":
      case "RED":
        isSideRed = true;
        break;
    }
    return string;
  };
  const matchTopColor = (string) => {
    isTopRed = false;
    switch (string) {
      case "BRRED":
      case "RED":
        isTopRed = true;
        break;
    }
    return string;
  };
  const matchRibColor = (string) => {
    isRibRed = false;

    if (snap.choices.ribs.selected.mode === "no") return "";
    if (snap.choices.ribs.selected.mode === "multiple") return "MUL";

    switch (string) {
      case "BRRED":
      case "RED":
        isRibRed = true;
        return string;
      default:
        return string;
    }
  };

  const matchSideLogo = () => {
    if (isSideRed | isTopRed | isRibRed) isRed = true;

    const design = (choice) => {
      switch (choice) {
        case "ENJ":
          return isRed ? "SMRENJ" : "SMENJ";
        default:
          return choice;
      }
    };

    return "-" + design(snap.choices.sideLogos.selected.abrv);
  };

  return (
    snap.initialChoices.inhouseCode +
    "-" +
    snap.initialChoices.make.abrv +
    matchStyle(snap.choices.ribs.selected.mode) +
    matchSideColor(snap.choices.sidePanels.selected.abrv) +
    matchTopColor(snap.choices.topPanel.selected.abrv) +
    matchRibColor(snap.choices.ribs.selected.rib[0].abrv) +
    matchSideLogo() +
    matchTopLogo()
  );
}

export default getKatanaSkew;
